import { useTranslation } from 'react-i18next';
import { AppToggleButtons } from '@/UI/AppToggleButtons/AppToggleButtons';
import { AppPaper, FlexCenVerSpaceBetween, FlexCol } from '@/UI/styles';
import { I18N_KEYS } from '@/language/keys';
import { WorkflowEditorMode } from '@/enums/workflow-editor-mode.enum';
import { ShareWorkflowButtonWithModal } from '../ShareWorkflowButtonWithModal';
import { BatchStatusButton } from '../../RunFlow/TaskManager/BatchStatusButton';
import { CREDITS_INFO_WIDTH } from '../../consts/ui';
import { WorkflowCreditsDisplay } from './WorkflowCreditsDisplay';
import { useWorkflowEditorMode } from './workflowEditorMode.store';

interface WorkflowRightToolbarProps {
  isPaperBg?: boolean;
}

export function WorkflowRightToolbar({ isPaperBg = true }: WorkflowRightToolbarProps) {
  const { t } = useTranslation();

  const { workflowEditorMode, setWorkflowEditorMode } = useWorkflowEditorMode();

  const Container = isPaperBg ? AppPaper : FlexCol;

  return (
    <Container
      sx={{
        ...(isPaperBg
          ? { p: 1, display: 'flex', flexDirection: 'column', width: CREDITS_INFO_WIDTH }
          : { width: '100%' }),
        gap: 1,
      }}
    >
      <FlexCenVerSpaceBetween sx={{ gap: 1 }}>
        <AppToggleButtons<WorkflowEditorMode>
          value={workflowEditorMode}
          options={[
            {
              value: WorkflowEditorMode.EditWorkflow,
              label: t(I18N_KEYS.RECIPE_MAIN.FLOW.WORKFLOW),
            },
            {
              value: WorkflowEditorMode.AppBuilder,
              label: t(I18N_KEYS.RECIPE_MAIN.FLOW.DESIGN_APP),
            },
          ]}
          onChange={(value) => {
            if (value) {
              setWorkflowEditorMode(value);
            }
          }}
        />
        <ShareWorkflowButtonWithModal />
      </FlexCenVerSpaceBetween>

      <FlexCenVerSpaceBetween sx={{ gap: 1 }}>
        <BatchStatusButton />
        <WorkflowCreditsDisplay />
      </FlexCenVerSpaceBetween>
    </Container>
  );
}
